<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    fill="none"
    class="spinner-progress">
    <defs>
      <linearGradient id="spinner-secondHalf">
        <stop
          offset="0%"
          stop-opacity="0"
          stop-color="currentColor" />
        <stop
          offset="100%"
          stop-opacity="0.5"
          stop-color="currentColor" />
      </linearGradient>

      <linearGradient id="spinner-firstHalf">
        <stop
          offset="0%"
          stop-opacity="1"
          stop-color="currentColor" />
        <stop
          offset="100%"
          stop-opacity="0.5"
          stop-color="currentColor" />
      </linearGradient>
    </defs>

    <g stroke-width="16">
      <path
        stroke="url(#spinner-secondHalf)"
        d="M 8 100 A 92 92 0 0 1 192 100" />

      <path
        stroke="url(#spinner-firstHalf)"
        d="M 192 100 A 92 92 0 0 1 8 100" />

      <path
        stroke="currentColor"
        stroke-linecap="round"
        d="M 8 100 A 92 92 0 0 1 8 98" />
    </g>

  </svg>
</template>

<script>
export default {
  name: 'SpinnerProgress',
};
</script>

<style scoped lang="scss">
.spinner-progress {
  --progress-color: #{$color--basic-blue};
  --size: 140px;

  width: var(--size);
  height: var(--size);
  color: var(--progress-color);
  animation: spinner-rotate 1s infinite linear;
}

@keyframes spinner-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
